<ng-container *ngIf="initialSelectedValue; else multiSelectElse">
  <ng-select #vs
             class="multilevel-separater border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none"
             [items]="_data"
             [(ngModel)]="initialSelectedValue"
             [ngClass]="_cssClass"
             appendTo="{{appendToBody?'body':null}}"
             bindValue="id"
             [bindLabel]="_bindLabel"
             [selectableGroup]="false"
             [searchFn]="searchAccounts"
             [closeOnSelect]="closeOnSelect"
             [clearable]="_clearable"
             [placeholder]="_placeHolder"
             [groupBy]="_groupBy"
             (change)="onSelect($event)"
             [disabled]="disabled"
             (blur)="onBlur()"
             [selectableGroup]="allowParentSelection"
             [loading]="isLoading"
             [multiple]="multiple"
  >

    <ng-template ng-optgroup-tmp
                 let-item="item">
      {{ item.name }}
    </ng-template>
    <ng-template ng-option-tmp
                 let-item="item">
      {{item.name}}
    </ng-template>
  </ng-select>

</ng-container>
<ng-template #multiSelectElse>
  <ng-select #vs
             class="multilevel-separater border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none"
             [items]="_data"
             [(ngModel)]="selected"
             [ngClass]="_cssClass"
             appendTo="{{appendToBody?'body':null}}"
             bindValue="id"
             [bindLabel]="_bindLabel"
             [selectableGroup]="false"
             [searchFn]="searchAccounts"
             [closeOnSelect]="closeOnSelect"
             [clearable]="_clearable"
             [placeholder]="_placeHolder"
             [groupBy]="_groupBy"
             (change)="onSelect($event)"
             [disabled]="disabled"
             (blur)="onBlur()"
             [selectableGroup]="allowParentSelection"
             [loading]="isLoading"
             [multiple]="multiple"
  >

    <ng-template ng-optgroup-tmp
                 let-item="item">
      {{ item.name }}
    </ng-template>
    <ng-template ng-option-tmp
                 let-item="item">
      {{item.name}}
    </ng-template>
  </ng-select>
</ng-template>